/* ================================================================
   YADOM LIFE — Site Behaviors + Optional Custom Cursor
   Scroll reveal, FAQ accordion, mobile nav, gallery, quantity all
   run ALWAYS. The sun cursor + star trail only run when
   window.YDM_CURSOR_ENABLED is true (set in theme.liquid from the
   enable_custom_cursor setting).
   ================================================================ */
(function () {
  'use strict';

  /* ---- Cursor config ---- */
  var STARS  = ['✦','★','✶','⊛','✸','⁕','◈','✺'];
  var COLORS = ['#F5C400','#C8001A','#2A6B2A','#D4621A'];
  var CURSOR_EMOJI = '☀';
  var TRAIL_INTERVAL = 70;  // ms between trail stars
  var TRAIL_LIFETIME = 650; // ms trail star lives
  var CURSOR_ID = 'ydm-cursor';

  /* ---- State ---- */
  var cursor = null;
  var lastTrail = 0;
  var mouseX = -999, mouseY = -999;
  var isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
               || window.matchMedia('(max-width:768px)').matches;

  /* ================================================================
     CUSTOM CURSOR (optional — only when enabled)
     ================================================================ */
  function initCursor() {
    if (isMobile) return;
    if (!window.YDM_CURSOR_ENABLED) return;

    injectCursorStyles();
    cursor = document.createElement('div');
    cursor.id = CURSOR_ID;
    cursor.setAttribute('aria-hidden','true');
    cursor.textContent = CURSOR_EMOJI;
    document.body.appendChild(cursor);

    document.addEventListener('mousemove', onMouseMove, { passive: true });
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mouseup',   onMouseUp);
    document.addEventListener('mouseleave', function() { cursor.style.opacity = '0'; });
    document.addEventListener('mouseenter', function() { cursor.style.opacity = '1'; });

    document.addEventListener('mouseover', function(e) {
      var el = e.target.closest('a,button,.button,.btn,input,label,[role="button"]');
      if (el) cursor.classList.add('ydm-cursor--hover');
    });
    document.addEventListener('mouseout', function(e) {
      var el = e.target.closest('a,button,.button,.btn,input,label,[role="button"]');
      if (el) cursor.classList.remove('ydm-cursor--hover');
    });
  }

  function onMouseMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    cursor.style.transform = 'translate(' + mouseX + 'px,' + mouseY + 'px)';
    var now = Date.now();
    if (now - lastTrail > TRAIL_INTERVAL) {
      lastTrail = now;
      spawnStar(mouseX, mouseY);
    }
  }
  function onMouseDown() { cursor.classList.add('ydm-cursor--click'); }
  function onMouseUp()   { cursor.classList.remove('ydm-cursor--click'); }

  function spawnStar(x, y) {
    var star = document.createElement('div');
    star.className = 'ydm-trail-star';
    star.setAttribute('aria-hidden','true');
    star.textContent = STARS[Math.floor(Math.random() * STARS.length)];
    star.style.color  = COLORS[Math.floor(Math.random() * COLORS.length)];
    star.style.fontSize = (10 + Math.random() * 10) + 'px';
    star.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    document.body.appendChild(star);

    var dx = (Math.random() - 0.5) * 40;
    var dy = -(20 + Math.random() * 30);
    var startTime = null;
    function animate(ts) {
      if (!startTime) startTime = ts;
      var progress = (ts - startTime) / TRAIL_LIFETIME;
      if (progress >= 1) { star.remove(); return; }
      var ease = 1 - Math.pow(1 - progress, 3);
      star.style.transform = 'translate(' + (x + dx * ease) + 'px,' + (y + dy * ease) + 'px)';
      star.style.opacity = 1 - progress;
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }

  function injectCursorStyles() {
    if (document.getElementById('ydm-cursor-styles')) return;
    var style = document.createElement('style');
    style.id = 'ydm-cursor-styles';
    style.textContent = [
      '*, *::before, *::after { cursor: none !important; }',
      '#' + CURSOR_ID + ' {',
      '  position: fixed; z-index: 99999; pointer-events: none; user-select: none;',
      '  width: 34px; height: 34px;',
      '  display: flex; align-items: center; justify-content: center;',
      '  font-size: 22px; line-height: 1;',
      '  background: #F5C400;',
      '  border: 2.5px solid #C8001A;',
      '  border-radius: 50%;',
      '  top: 0; left: 0;',
      '  transform: translate(-999px,-999px);',
      '  transition: transform 0.04s linear, width 0.2s, height 0.2s, font-size 0.2s, box-shadow 0.2s;',
      '  box-shadow: 0 0 0 3px rgba(200,0,26,0.2);',
      '}',
      '#' + CURSOR_ID + '.ydm-cursor--hover {',
      '  width: 48px; height: 48px; font-size: 28px;',
      '  box-shadow: 0 0 0 5px rgba(200,0,26,0.35), 0 0 16px rgba(245,196,0,0.6);',
      '}',
      '#' + CURSOR_ID + '.ydm-cursor--click {',
      '  transform: translate(var(--ydm-cx,0px),var(--ydm-cy,0px)) scale(0.82) !important;',
      '  box-shadow: 0 0 0 8px rgba(200,0,26,0.5), 0 0 24px rgba(245,196,0,0.8);',
      '}',
      '.ydm-trail-star {',
      '  position: fixed; z-index: 99998; pointer-events: none; user-select: none;',
      '  top: 0; left: 0; font-size: 14px; font-style: normal;',
      '  transform-origin: center center;',
      '  will-change: transform, opacity;',
      '}',
      '@media (max-width: 768px) { *, *::before, *::after { cursor: auto !important; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

  /* ================================================================
     SCROLL REVEAL (always on) — fades in .ydm-reveal elements
     ================================================================ */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.ydm-reveal:not(.ydm-observed)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      // Fallback: no observer support, just show everything.
      targets.forEach(function(el) { el.classList.add('ydm-observed', 'is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function(el) {
      el.classList.add('ydm-observed');
      observer.observe(el);
    });
  }

  /* ---- Mobile nav toggle ---- */
  function initMobileNav() {
    var toggle = document.querySelector('.header__hamburger');
    var nav    = document.querySelector('.mobile-nav');
    var close  = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    if (close) close.addEventListener('click', function() { nav.classList.remove('is-open'); document.body.style.overflow = ''; });
    nav.addEventListener('click', function(e) { if (e.target === nav) { nav.classList.remove('is-open'); document.body.style.overflow = ''; } });
  }

  /* ---- Accordion / FAQ ---- */
  function initAccordion() {
    document.querySelectorAll('.accordion__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var items = trigger.closest('.accordion').querySelectorAll('.accordion__trigger');
        items.forEach(function(t) {
          t.setAttribute('aria-expanded','false');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.classList.remove('is-open');
        });
        if (!expanded) {
          trigger.setAttribute('aria-expanded','true');
          if (panel) panel.classList.add('is-open');
        }
      });
    });
  }

  /* ---- Product gallery thumbnails ---- */
  function initProductGallery() {
    document.querySelectorAll('.product-media__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.querySelector('img') ? thumb.querySelector('img').src : null;
        if (!src) return;
        var main = thumb.closest('.product-media').querySelector('.product-media__main img');
        if (main) main.src = src;
        thumb.closest('.product-media__thumbs').querySelectorAll('.product-media__thumb').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Quantity stepper ---- */
function initQuantity() {

  // Skip quantity handling on Cart page
  if (document.body.classList.contains('template-cart')) {
    return;
  }

  document.querySelectorAll('.product-form__quantity').forEach(function(wrapper) {

    var input = wrapper.querySelector('.product-form__quantity-input');
    if (!input) return;

    var minusBtn = wrapper.querySelector('.qty-minus');
    var plusBtn = wrapper.querySelector('.qty-plus');

    if (minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();

        var value = parseInt(input.value, 10) || 1;
        if (value > 1) {
          input.value = value - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();

        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

  });

}

  /* ================================================================
     BOOT
     ================================================================ */
  function boot() {
    initCursor();
    initScrollReveal();
    initMobileNav();
    initAccordion();
    initProductGallery();
    initQuantity();

    // Re-run reveal when Shopify injects sections (theme editor / lazy content)
    if ('MutationObserver' in window) {
      new MutationObserver(function(muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { initScrollReveal(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
